// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../pin-cross-reference/state/criteria';
import actions from '../../actions-list';

const updatePinCrossReferenceCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_PIN_CROSS_REFERENCE_CRITERIA]: updatePinCrossReferenceCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/reducers/criteria.js